export const AppLayoutContentContainerId = 'app-layout-content-container';

const getAppLayoutContentContainerElement = () => {
  return document.getElementById(AppLayoutContentContainerId);
};

export default getAppLayoutContentContainerElement;
